import Service, { inject as service } from '@ember/service';

export default class InvoiceActionsService extends Service {
  @service fetch;

  regenerate(invoice) {
    return this.fetch.post(`/invoices/${invoice.id}/regenerate`);
  }
}
